import React, { useEffect, useState } from 'react'
import Wrapper from '../UI/Wrapper'
import Sidebar from '../components/Common/Sidebar'
import Main from '../components/FormScreen/Main'
import { BASE_URL,RAZORPAY_KEY } from '../keys'
import { useDispatch } from 'react-redux'
import { therapistActions } from '../services/therapistSlice'
import ReactGA from 'react-ga'
import {
    useGetPlanListQuery,
    usePlanPurchaseMutation,
} from '../services/planApi'
import { useGetCategoriesQuery } from '../services/categoryApi'
import { useSelector } from 'react-redux'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { useGetCurrentUserQuery } from '../services/authApi'
import { useOpenProfileMutation } from '../services/chatApi'
import emptyavatar from '../assets/images/emptyavatar.webp'

const ChoosePlan = () => {
  
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const handleClick = (color) => {
        dispatch(therapistActions.setBG(`bg-[${color}]`))
    }
    const catId = useSelector((state) => state.coachReducer.coach_category_id)
    // console.log(catId);
    
    const categoryId = useSelector((state) => state.therapistReducer.categoryId)
    // console.log(categoryId);
    const coachName = useSelector((state) => state.coachReducer.coachName)
    const currency = useSelector((state) => state.therapistReducer.currency)
    // console.log(currency);
    const [currencyIdStr, currencyCode] = currency?.split(' ') || []
    // console.log(currencyCode);
const currencyIdFromRedux = parseInt(currencyIdStr, 10)
    const currencyId = parseInt(currencyIdStr, 10)
    // console.log(currencyId);
    const [currencycode, setCurrencyCode] = useState('AED')
    const [currentuser, setCurrentUser] = useState()
    const coachId = useSelector((state) => state.coachReducer.coach_id)
    const bookingId = useSelector((state) => state.bookingReducer.bookingId)
//    console.log(coachId);
   
const location = useLocation()
const coachIdFromState = location.state?.coachId
console.log(coachIdFromState);

    const [amount, setAmount] = useState()
    const [selectedPlan, setSelectedPlan] = useState('')
    const [selectedCategory, setSelectedCategory] = useState(null)

  const [currencyID, setCurrencyID] = useState(() => {
    const stored = JSON.parse(localStorage.getItem("currency") || "{}");
    return stored?.id || 1; // Default to AED (id=1)
  });

  const [categoryID, setCategoryID] = useState(() => {
    return localStorage.getItem("categoryid") || null;
  });
const displayCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
useEffect(() => {
        // Only run if the Redux currency state is available and its ID is different from the current local state
        if (currencyIdFromRedux && currencyIdFromRedux !== currencyID) {
            setCurrencyID(currencyIdFromRedux); // Update local state
            // NOTE: We don't call refetch here. We let the next effect handle it.
        }
    }, [currencyIdFromRedux, currencyID]); 

useEffect(() => {
  if (!currency) return;
  const [idStr] = currency.split(" ");
  const id = parseInt(idStr, 10);
  if (id !== currencyID) setCurrencyID(id);
}, [currency]);
// console.log(displayCurrency);

  // 👇 Listen for changes in localStorage (in case they change elsewhere)
  useEffect(() => {
    const handleStorageChange = () => {
      const storedCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
      const storedCategory = localStorage.getItem("categoryid");
// console.log(storedCurrency);

      if (storedCurrency?.id && storedCurrency.id !== currencyID) {
        setCurrencyID(storedCurrency.id);
        refetch();
      }
      if (storedCategory && storedCategory !== categoryID) {
        setCategoryID(storedCategory);
        refetch();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [currencyID, categoryID]);
    // Fetch categories from API
    const { data: categoriesData, isLoading: isCategoriesLoading } =
        useGetCategoriesQuery()
    const [planPurchase] = usePlanPurchaseMutation()
    // console.log(categoryID,currencyID);
    
    const { data: plansData,refetch } = useGetPlanListQuery(
  { categoryID, currencyID },
      { skip: !categoryID || !currencyID }

);
    // console.log(plansData);
    
    const [openProfile, { isLoading, isError }] = useOpenProfileMutation()
    const resolvedCoachId = coachId || localStorage.getItem('coach_id')
    const profileOpenHandler = async (idParam) => {
        console.log(coachIdFromState);
        
        const id = coachIdFromState  
        if (!id) return

        const formData = new FormData()
        formData.append('person_id', id)

        const response = await openProfile(formData)

        if (response?.data) {
            setCurrentUser(response.data.data)
            try {
                localStorage.setItem('coach_id', id)
            } catch (e) {
                // ignore localStorage errors
            }
        }
    }

    useEffect(() => {
        profileOpenHandler()
    }, [resolvedCoachId])
    // console.log(selectedPlan);
    const { data: userDetails } = useGetCurrentUserQuery({})
    
    const selectedPlanObj = plansData?.data?.find(
        (item) => item.id === selectedPlan
    )
    // console.log(selectedPlanObj);
    useEffect(() => {
        if (selectedPlanObj?.currency_id === currencyId) {
            setCurrencyCode(currencyCode)
        }
    }, [selectedPlanObj, currencyId, currencyCode])
    const handleContinue = async () => {
        if (!selectedPlan) return

        try {
            const payload = {
                category_id: categoryID,
                plan_id: selectedPlan,
                booking_id: localStorage.getItem('livBookingId'),
                coach_id: coachId,
                currency_id:currencyID
            }

            const response = await planPurchase(payload).unwrap()
            // console.log('Plan purchase success:', response);
            // console.log(amount);
            
            if (response?.code === 'Success') {
                // console.log("kkk");
                
                //   razorpay
                const order_id = response.data
                const options = {
                     key: RAZORPAY_KEY,
                    //  key:"rzp_live_RcR0Eyfy5CToJ5",
                    // key: 'rzp_test_nlYlH13408kYk6', // test key
                    amount: parseInt(amount) * 100,
                    currency: displayCurrency.code,
                    name: 'hapsmith',
                    description: 'Slot Booking',
                    // image: "/your-logo.png", // optional
                    order_id: order_id,
                    handler: function (response) {
                        //   console.log("Payment Success:", response);

                        if (response) {
                            toast.success('Payment Successful! Redirecting...')
                            setTimeout(() => {
                                navigate(`/chat/${coachId}`)
                            }, 2000)
                        } else {
                            toast.error('Payment failed try again')
                            // setPayNow(true)
                        }
                    },
                    prefill: {
                        name: userDetails?.data?.name || '',
                        email: userDetails?.data?.email || '',
                    },
                    theme: {
                        color: '#F77F11',
                    },
                    modal: {
                        ondismiss: function () {
                            toast.error('Payment Failed')
                            // console.log('Checkout form closed');
                        },
                    },
                }

                const rzp = new window.Razorpay(options)
                rzp.open()
            } else {
                const errorMsg =
                    response?.data?.error[0] || 'Payment failed, try again'
                toast.error(errorMsg)
            }
            // Redirect or show success message
        } catch (error) {
            toast.error(error?.data?.data?.error[0])
            // console.error('Plan purchase error:', error);
            // Show error toast/message
        }
    }


    return (
        <Wrapper>
            <div className="flex ">
                <Sidebar notLoggedIn={false} />
                <Main>
                    <ToastContainer hideProgressBar />
                    <section className="flex rounded-2xl bg-[#FDF5EE] w-full px-40 items-center justify-center my-4 ">
                        {/* <div className="bg-[#FDE9D8]  py-8 my-10 w-[60%] flex flex-col items-center justify-center rounded-[20px] px-10 lg:max-h-[80vh] overflow-y-auto"> */}
                        <div className="bg-[#FDE9D8]  py-8 my-10 w-[60%] flex flex-col items-center justify-center rounded-[20px] px-10 lg:max-h-[80vh] overflow-y-auto">
                            <h2 className="font-constantia font-bold text-3xl my-2 pt-2">
                                Choose Your Plan
                            </h2>
                            <p className="font-constantia font-semibold text-lg mb-4">
                                Unlock your endless possibilities
                            </p>
                            {/* Profile Section */}

                            <div className="bg-white rounded-[20px] p-6 mb-10 w-full">
                                <div className="flex  items-center justify-center gap-8">
                                    <div className="flex flex-col gap-2 items-center justify-center">
                                        <div>
                                            <img
                                                className="w-[55px] h-[55px] rounded-full object-cover"
                                                alt="image"
                                                src={
                                                    currentuser?.profile_pic
                                                        ? `${BASE_URL}${currentuser?.profile_pic}`
                                                        : emptyavatar
                                                }
                                                onError={(e) => {
                                                    e.currentTarget.src =
                                                        emptyavatar
                                                }}
                                            />
                                            <p className="text-[20px] font-constantia font-medium">
                                                {currentuser?.name}
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <ul className="mt-2 space-y-2 text-[16px] text-left">
                                            {[
                                                currentuser?.email,
                                                currentuser?.category_name,
                                                Array.isArray(
                                                    currentuser?.specializations
                                                )
                                                    ? currentuser.specializations
                                                          .filter(Boolean)
                                                          .map((s) => s.trim())
                                                          .join(', ')
                                                    : '',
                                                Array.isArray(
                                                    currentuser?.languages
                                                )
                                                    ? currentuser.languages
                                                          .map(
                                                              (lang) =>
                                                                  lang.name
                                                          )
                                                          .join(', ')
                                                    : '',
                                            ].map((text, index) => (
                                                <li
                                                    key={index}
                                                    className="flex items-start gap-2"
                                                >
                                                    <svg
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 28 28"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="mt-1"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M27.3332 14C27.3332 21.3638 21.3636 27.3333 13.9998 27.3333C6.63604 27.3333 0.666504 21.3638 0.666504 14C0.666504 6.63616 6.63604 0.666626 13.9998 0.666626C21.3636 0.666626 27.3332 6.63616 27.3332 14ZM19.3736 9.95952C19.7641 10.35 19.7641 10.9832 19.3736 11.3737L12.7069 18.0404C12.3164 18.4309 11.6833 18.4309 11.2927 18.0404L8.62606 15.3737C8.23554 14.9832 8.23554 14.35 8.62606 13.9595C9.01659 13.569 9.64975 13.569 10.0403 13.9595L11.9998 15.9191L14.9796 12.9393L17.9594 9.95952C18.3499 9.569 18.9831 9.569 19.3736 9.95952Z"
                                                            fill="#F76411"
                                                        />
                                                    </svg>
                                                    <span className="text-[16px] font-constantia">
                                                        {text}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Plans */}
                            <div className="space-y-6 mb-6 w-full">
                                {plansData && plansData?.data.length > 0 ? (
                                    plansData?.data?.map((plan) => (
                                        <label
                                            key={plan.id}
                                            className="bg-white rounded-[20px] p-6 relative flex items-start gap-4 cursor-pointer border-2 transition-all"
                                            style={{
                                                borderColor:
                                                    selectedPlan === plan.id
                                                        ? '#F76411'
                                                        : 'transparent',
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                name="plan"
                                                value={plan.id}
                                                className="hidden"
                                                onChange={() => {
                                                    setSelectedPlan(plan.id)
                                                    setAmount(plan?.price?.amount)
                                                }}
                                                checked={
                                                    selectedPlan === plan.id
                                                }
                                            />
                                            <div
                                                className={`w-5 h-5 min-w-[20px] min-h-[20px] mt-2 flex items-center justify-center rounded-full border-2 transition-all ${
                                                    selectedPlan === plan?.id
                                                        ? 'bg-[#F76411] '
                                                        : 'border-gray-400'
                                                }`}
                                            >
                                                {selectedPlan === plan.id && (
                                                    <svg
                                                        className="w-3 h-3 text-white"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="3"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M5 13l4 4L19 7"
                                                        />
                                                    </svg>
                                                )}
                                            </div>

                                            <div className="flex justify-between items-start w-full ">
                                                <div>
                                                    <div className="bg-[#F76411] absolute rounded-[20px] -top-4 left-6 text-[16px] px-4 py-1 inline-block text-white">
                                                        {plan?.category_id === 3
                                                            ? 'Fitness & Nutrition'
                                                            : 'Therapy'}
                                                    </div>
                                                    <p className="text-[25px] font-bold font-sans">
                                                        {plan?.name}
                                                    </p>
                                                    <p className="text-[16px] text-[#868686] font-sans">
                                                        Total Sessions{' '}
                                                        {
                                                            plan?.free_consultation_no
                                                        }
                                                    </p>
                                                </div>
                                                <div className="text-right">
                                                    <p className="text-[25px] font-bold">
                                                        {displayCurrency?.code} {plan?.price?.amount}
                                                    </p>
                                                    {/* <p className="text-[16px] text-[#868686] font-sans">
                                                {plan?.month*30} days
                                            </p> */}
                                                </div>
                                            </div>
                                        </label>
                                    ))
                                ) : (
                                    <div className="flex justify-center">
                                        No Plans Available
                                    </div>
                                )}

                                {plansData && plansData?.data.length > 0 && (
                                    <button
                                        className={`bg-[#FFDBB0] w-full mt-5 font-ubuntu text-center h-[40px] rounded-[20px] font-bold text-[#F77F1F] ${
                                            selectedPlan
                                                ? 'opacity-100 cursor-pointer'
                                                : 'opacity-50 cursor-not-allowed'
                                        }`}
                                        disabled={!selectedPlan}
                                        onClick={handleContinue}
                                    >
                                        Continue
                                    </button>
                                )}
                            </div>
                        </div>
                    </section>
                </Main>
            </div>
        </Wrapper>
    )
}

export default ChoosePlan
